<template>
  <div>
    <div class="login-box" v-if="isShowLogin">
      <div class="login">
        <img @click="closeLoginBox" class="pic-close" src="../assets/images/close.png" />
        <img class="pic" src="../assets/images/login-left.png" />
        <div class="login-right">
            <div v-if="!weiXinLogin">
                <div class="title">登录</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :show-message="false" >
              <el-form-item  prop="phone" class="form-item">
                <div class="input-box">
                  <div v-if="phoneTipShow" @click="phoneClickHandler" class="phone-tip">手机号</div>
                  <div v-else class="label-title">手机号</div>
                  <el-input v-model="ruleForm.phone" name="tel" ref="mobileFocus" @blur="phoneBlur"  @focus="phoneFocus"></el-input>
                </div>
              </el-form-item>
              <el-form-item v-if="tabIndex === 1"  prop="code" class="form-item-code">
                <div class="input-box">
                  <div v-if="codeTipShow" @click="codeClickHandler" class="phone-tip">验证码</div>
                  <div v-else class="label-title">验证码</div>
                  <el-input v-model="ruleForm.code" ref="codeFocus" @focus="codeFocus" @blur="codeBlur"></el-input>
                  <div v-if="showGetCode" @click="getCodeHandler" class="get-code get-code-cur">获取验证码</div>
                  <div v-else class="get-code re-get-code">重新获取({{codeTimeCut}})</div>
                </div>
              </el-form-item>
              <el-form-item v-else prop="code" class="form-item-code">
                <div class="input-box">
                  <div v-if="codeTipShow" @click="codeClickHandler" class="phone-tip">密码</div>
                  <div v-else class="label-title">密码</div>
                  <el-input type="password" v-model="ruleForm.code" ref="codeFocus" @focus="codeFocus" @blur="codeBlur"></el-input>
                </div>
              </el-form-item>
              <el-form-item class="form-item-agreement">
                <div class="txt-agreement">
                  点击登录代表您已阅读并接受 
                  <span class="proxy" @click="proxyHandler">《用户隐私与注册条款》</span>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button class="login-button" type="primary" round @click="loginHandler">登录</el-button>
              </el-form-item>
            </el-form>
              
            </div>
            <div v-if="weiXinLogin">
              <div class="wx-login-box">
                  <div class="erweima-box">
                    <img class="erweima" :src="erweimaUrl" alt="">
                    <div class="isScanCode" v-if="isScanCode">
                      <img class="scanCode-img" src="../assets/images/icons/success-icon.png" />
                      <div class="reScanCode" @click="reScanCode">重新扫码</div>
                    </div>
                  </div>
                   <div class="wxloginText">{{wxloginText}}</div>
              </div>
            </div>
            <div class="bot-cont">
              <img class="weixin-login" @click="goWxLogin" src="https://wxapp-1254383113.file.myqcloud.com/fe-wxapp-img/icon-weixin-logo.png" alt="" />
              <div v-if="tabIndex === 1" class="other-way-login" @click="loginWay(2)">密码登录</div>
              <div v-else class="other-way-login" @click="loginWay(1)">短信登录</div>
              <div class="m-login" @click="forgetPwdHandler">忘记密码</div>
            </div>
        </div>
      </div>
    </div>
    <forgetPwd :forgetPwdShow="forgetPwdShow" @closeResetodal="closeResetodal" @resetPwdSuccess="resetPwdSuccess" />
  </div>
</template>

<script>
  import forgetPwd from './forget';
  import { login, getCode ,loginQrcode,loginQrcodeCheck} from '../server/me';
  import { setCookie } from '../utils/utils';
  import { mapGetters } from 'vuex';
  export default {
    name: 'login',
    data () {
      // 手机格式验证
      const validatorPhone = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入手机号!'))
        } else {
          if (!/^1[3456789]\d{9}$/.test(value)) {
            callback(new Error('手机号格式不正确!'))
          } else {
            callback()
          }
        }
      }

      // 验证码和密码格式验证
      const validrCodePwd = (rule, value, callback) => {
        const tabIndex = Number(this.tabIndex) - 1;
        const regArr = ["\\d{4}$", "^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$"]
        const msg1 = ["请输入手机验证码", "请输入密码"];
        const msg2 = ["手机验证码格式不正确", "密码格式不正确"];
        const reg = new RegExp(regArr[tabIndex])
        if (!value) {
          callback(new Error(msg1[tabIndex]))
        } else {
          if (!reg.test(value)) {
            callback(new Error(msg2[tabIndex]))
          } else {
            callback()
          }
        }
      }

      return {
        weiXinLogin:false,
        isScanCode:false,
        uuid:'',
        erweimaUrl:'',
        timer: '',
        tabIndex: 2,
        showGetCode: true,
        codeTimeCut: 60,
        phoneTipShow: true,
        codeTipShow: true,
        forgetPwdShow: false,
        wxloginText:'微信扫码登录',
        timerState:null,
        ruleForm: {
          phone: "",
          code: ""
        },
        rules: {
          phone: [
            { validator: validatorPhone, trigger: 'blur' },
          ],
          code: [
            { validator: validrCodePwd, trigger: 'blur' },
          ]
        }
      }
    },
    inject: ['reload'],
    computed: {
      ...mapGetters([
        'isShowLogin'
      ])
    },
    components: {
      forgetPwd
    },
    methods: {
      reScanCode(){
        clearInterval(this.timerState)
        this.isScanCode = false
        this.goWxLogin()
      },
      async goWxLogin(){
        this.weiXinLogin = true
        const data = await loginQrcode();
        if (data.code === 0) {
          this.uuid = data.uuid
          this.erweimaUrl = data.imgData
          this.getScanCodeState()
        } else {
          this.$message.error(data.msg);
        }
      },
      getScanCodeState(){
        this.timerState = setInterval(async () => {
          const data = await loginQrcodeCheck({uuid:this.uuid});
          if(data.state == 1){
            this.isScanCode = true
          }
          if(data.state == 2){
            this.initWxLogin()
            this.$emit('loginOKHandler', data);
            setCookie('uid', data.userId, 1);
            setCookie('sessionkey', data.sessionKey, 1);
              this.reload()
            }
        },1000)
      },
      closeLoginBox() {
        this.initWxLogin()
        this.$emit('closeLoginModal'); //通知父组件改变。
      },
      initWxLogin(){
        this.isScanCode = false
        this.weiXinLogin = false
        clearInterval(this.timerState)
      },
      loginWay(index) {
        this.initWxLogin()
        this.weiXinLogin = false
        this.$nextTick(() => {
          this.clearForm("ruleForm")
          this.tabIndex = Number(index);
        })
      },
      getCodeHandler() {
        this.$refs['ruleForm'].validateField("phone", (errorMessage) => {
          if (errorMessage) {
            this.$message({
              center: true,
              message: errorMessage,
              type: 'error',
              duration: "1000"
            });
          } else {
            this.showGetCode = false;
            this.getMobileCode();
            this.timer = setInterval(() => {
              this.codeTimeCut --;
              if (this.codeTimeCut <= 0) {
                this.codeTimeCut = 60;
                this.showGetCode = true;
                clearInterval(this.timer);
              }
            }, 1000);
          }
        });
      },
      phoneFocus() {
        this.phoneTipShow = false;
      },
      phoneBlur() {
        if (this.ruleForm.phone) {
          this.phoneTipShow = false;
        } else {
          this.phoneTipShow = true;
        }
        
      },
      codeFocus() {
        this.codeTipShow = false;
      },
      codeBlur() {
        if (this.ruleForm.code) {
          this.codeTipShow = false;
        } else {
          this.codeTipShow = true;
        }
        
      },
      codeClickHandler() {
        const _this = this;
        _this.codeTipShow = false;
        setTimeout(function() {
          _this.$nextTick(() => {
            _this.$refs.codeFocus.focus()
          })
        }, 0);
      },
      phoneClickHandler() {
        const _this = this;
        _this.phoneTipShow = false;
        setTimeout(function() {
          _this.$nextTick(() => {
            _this.$refs.mobileFocus.focus()
          })
        }, 0);
      },
      async getMobileCode() {
        const obj = {
          tel: this.ruleForm.phone,
          type: 12
        };
        const { code = 1, msg = '' } = await getCode(obj);
        if (code === 0) {
          this.$message({
            message: msg,
            type: "success"
          });
        } else {
          this.$message.error(msg);
        }
      },
      loginHandler() {
        this.$refs['ruleForm'].validate((valid, obj) => {
          if (valid) {
            this.loginSuccessHandler();
          } else {
            let status = true;
            Object.keys(this.ruleForm).map((key) => {
              this.$refs['ruleForm'].validateField(key, (errorMessage) => {
                if (errorMessage && status) {
                  status = false;
                  this.$message({
                    center: true,
                    message: errorMessage,
                    type: 'error',
                  });
                  return;
                }
              })
            });
          }
        })
      },
      async loginSuccessHandler() {
        const tabIndex = Number(this.tabIndex);
        const type = tabIndex === 1 ? "sms" : "pwd";
        let obj = {
          tel: this.ruleForm.phone,
          type: type
        };
        (tabIndex === 1) ? obj.authCode = this.ruleForm.code : obj.pwd = this.ruleForm.code;
        const { code = 1, msg = '', ...res } = await this.$store.dispatch('user/loginHandler', obj);
        if (code === 0) {
          const { data = {} } = res;
          this.$emit('loginOKHandler', data);
          this.clearForm("ruleForm")
          setCookie('uid', data.userId, 1);
          setCookie('sessionkey', data.sessionKey, 1);
          this.reload()
        } else {
          this.$message.error(msg);
        }
      },
      proxyHandler() {
        const { href } = this.$router.resolve({
          name: "proxyPage",
          query: {}
        });
        window.open(href, '_blank');
      },
      forgetPwdHandler() {
        this.initWxLogin()
        this.forgetPwdShow = true;
        this.$store.dispatch('user/openLogin', false);
      },
      resetPwdSuccess() {
        this.closeResetodal();
        this.tabIndex = 2;
      },
      closeResetodal() {
        this.forgetPwdShow = false;
        this.weiXinLogin = false
      },
      clearForm(formName) {
        this.$refs[formName].resetFields();
        this.codeBlur();
        this.phoneBlur();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="./scss/login.scss"></style>
<style lang="scss" src="./scss/login-variables.scss"></style>


// WEBPACK FOOTER //
// src/components/login.vue